<template>
  <div v-if="critereRecherche" class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeDevis.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <router-link :to="{ name: 'm.bodac.devis-creation' }">
              <a class="button is-addOrEdit"
                 :class="{ 'button-access-no-permission' : !checkPermissions(permDevis.maj) }">
                {{ $t('listeDevis.actions.newQuotation')}}
              </a>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-actions
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllDevisSelected().length > 0"
            ></selecteur-actions>
          </div>
          <form @submit.prevent="recherche()" class="column is-5 pdr-0 pdl-0">
            <b-input :placeholder="$t('listeDevis.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('listeDevis.actions.filtre') }}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permDevis.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <a ref="lienDownload"></a>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable"
      v-if="startArrayRendering && mountedLoadingEnd">
        <template slot='afterTable'>
          <table-items-in-view
            :perPage="resultPerPage"
            @input='$refs[referenceTable].setLimit($event)'/>
        </template>
        <template slot='appendBody'>
          <table-footer-totaux
            ref="tableTotaux"
            :columns="columns"
            :target="targetTotal"
            :items="devis">
          </table-footer-totaux>
        </template>
        <div slot="selected" slot-scope="props" class="has-text-centered">
          <qd-checkbox v-model="props.row.selected">
          </qd-checkbox>
        </div>
        <div slot="code" slot-scope="props"
             :class="{ 'textDecorationLineThrough': props.row.etat === sansSuite }">
          <section class="is-flex is-justify-content-space-between">
            <router-link :to="{ name: 'c.bodac.devis', params: {id: props.row.id}}"
                         class="lien"
                         :class="{'text-access-no-permission':
                       !checkPermissions(permDevis.lecture)}">
              {{props.row.code}}
            </router-link>
            <tag-list
              class="mgl-2 is-justify-content-flex-end"
              v-if="getListeTags(props.row)"
              :listes="getListeTags(props.row)"/>
          </section>
        </div>
        <div slot="commercialId" slot-scope="props"
             :class="{ 'textDecorationLineThrough': props.row.etat === sansSuite }">
          {{props.row.nomCommercial}}
        </div>
        <div slot="listeIntervenants" slot-scope="props">
          <router-link-blank
            v-for="(intervenant, index) in props.row.intervenants"
            :key="index"
            :to="{ name: 'c.bodac.clients/contacts-client',
            params: { id: intervenant.tiersId }}"
            :message="intervenant.nomCommercial"
            :class="{ 'textDecorationLineThrough': props.row.etat === sansSuite }">
          </router-link-blank>
        </div>
        <div slot="etat" slot-scope="props">
          {{ $t(props.row.etatLibelle) }}
        </div>
        <div slot="codeDossier" slot-scope="props"
             :class="{ 'textDecorationLineThrough': props.row.etat === sansSuite }"
        >
          {{ props.row.codeDossier }}
        </div>
        <div slot="dateDevisCommande" slot-scope="props" v-if="props.row.dateDevisCommande"
             :class="{ 'textDecorationLineThrough': props.row.etat === sansSuite }">
          {{props.row.dateDevisCommande | formatDate}}
        </div>
        <div slot="datePremierAffichage" slot-scope="props"
             :class="{ 'textDecorationLineThrough': props.row.etat === sansSuite }">
          {{props.row.datePremierAffichage | formatDate}}
        </div>
        <div slot="estSigne" slot-scope="props">
          <section class="is-flex is-align-items-center">
            {{ $t(`general.${props.row.estSigne ? 'oui' : 'non'}`) }}
            <b-icon
              v-if="moduleSignatureElectroniqueActive && props.row.estSigneElectroniquement"
              icon="signature-freehand"
              class="mgl-1"/>
          </section>
        </div>
        <div slot="montantHt" slot-scope="props" class="is-pulled-right"
             :class="{ 'textDecorationLineThrough': props.row.etat === sansSuite }">
          {{props.row.montantHt | formatDevise}}
        </div>
        <div slot="editer" slot-scope="props" >
          <btn-action-icon
            :tooltip-label="$t('general.button.edition')"
            :permission="permDevis.editer"
            @is-click="edition({format: pdf, typeDonnee: typeEditionDevis}, props.row.id)"
            icon="file-pdf-box">
          </btn-action-icon>
        </div>
        <div slot="categorieVente" slot-scope="props">
          {{ $t(getLibelleCategorieVente(props.row.categorieVente)) }}
        </div>
        <div slot="modifier" slot-scope="props" class="has-text-centered">
          <btn-action-icon
            :tooltip-label="$t('general.button.edit')"
            :disabled="props.row.etat === sansSuite
              || props.row.etat === constantes.ETAT_BROUILLON
              || props.row.etat === commande"
            :permission="permDevis.maj"
            :tooltip-position="'is-top'"
            @is-click="$router.push({name: 'm.bodac.devis', params: {id: props.row.id}})"
            icon-type="is-success"
            icon="pencil-box-outline">
          </btn-action-icon>
        </div>
        <div slot="archive" slot-scope="props" class="has-text-centered">
          <btn-action-icon
            :tooltip-label="checkDesactiveButton(props.row.id)
              ? $t('detailDevis.infoButtonDesactiver') : $t('general.button.archiver')"
            :disabled="props.row.etat === constantes.ETAT_BROUILLON
              || checkDesactiveButton(props.row.id)"
            :permission="permDevis.supprimer"
            :tooltip-position="checkDesactiveButton(props.row.id) ? 'is-left' : 'is-top'"
            @is-click="inProgress()"
            icon-type="is-default"
            icon="archive">
          </btn-action-icon>
        </div>
        <div slot="supprimer" slot-scope="props" class="has-text-centered">
          <btn-action-icon
            :tooltip-label="checkDesactiveButton(props.row.id)
              ? $t('detailDevis.infoButtonDesactiver') : $t('general.button.delete')"
            :disabled="props.row.etat === sansSuite
              || props.row.etat === constantes.ETAT_BROUILLON
              || props.row.etat === constantes.ETAT_COMMANDE_PARTIELLEMENT
              || props.row.etat === commande"
            :permission="permDevis.supprimer"
            :tooltip-position="checkDesactiveButton(props.row.id) ? 'is-left' : 'is-top'"
            @is-click="supprimerDevis(props.row)"
            icon-type="is-danger"
            icon="delete-forever">
          </btn-action-icon>
        </div>
      </v-server-table>
      <b-modal v-model="isComponentSupprimerDevis"
               has-modal-card
               class="modal" @close="devisASupp = []">
        <app-confirmation-suppression-commande
          :devisCommandes="devisASupp"
          @rechargement='rechargementSuiteSuppression()'
          :type="type"/>
      </b-modal>
    <b-modal v-model="openPopUpSansSuite" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('listeDevis.popUpSansSuiteMess')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :isErrorPopup.sync='isErrorPopup'
        :messagesPopup='messagesPopup'
        @no="openPopUpSansSuite = false"
        @yes="classerSansSuite()">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="openPopupMassCommercial" has-modal-card class="modal"
      v-if="!modulePresseActive">
      <pop-up-changement-commercial
        @onEditAllCommercialUpdated="updateMassCommercial"
        :isDevis="true"
        :elementsSelectionnes="getAllDevisSelected()"
        @close="openPopupMassCommercial = false">
      </pop-up-changement-commercial>
    </b-modal>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-commande-devis ref="filtreListeCommandeDevis"
                                     :isDevis="true"
                                     @toggleFiltre="changeValueShowFiltreAndLockMenu"
                                     v-model="critereRecherche"
                                     @recherche="makeRechercheFilter()"/>
      </div>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE, NO_PAGINATION,
} from '@/configuration/clientTableConf';
import { CATEGORIE_PRODUIT } from '@/configuration/catalogue/produitConf';
import * as devisConf from '@/configuration/devisConf';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import inProgress from '@/services/general/inProgress';
import AppBreadcrumb from '@/components/general/breadcrumb';
import BtnActionIcon from '@/components/general/btnActionIcon';
import { DEVIS } from '@/configuration/permissionsBodacConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import checkPeriodeAndFormat from '@/services/dcf/checkPeriodeAndFormat';
import genererCritereRecherche from '@/services/devisCommandes/genererCritereDevisCommande';
import selecteurActions from '@/components/general/selecteurAction';
import {
  ACTION_DELETE,
  ACTION_MASS_CHANGER_COMMERCIAL,
} from '@/configuration/general/actionsConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import messageErreur from '@/services/general/messageErreur';
import edition from '@/api/edition';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import transform from '@/services/devisCommandes/filters/devisCommandeServerTableDataTransformer';
import parametrageTable from '@/components/general/parametrageTable';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import PopUpPrevention from '@/components/general/popUpPrevention';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { REFERENCE_TABLE_DEVIS } from '@/configuration/general/referenceTableConf';
import devisSansSuiteMulti from '@/services/devisCommandes/devisSansSuiteMulti';
import messageSuccess from '@/services/general/messageSucces';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { getAll as getAllSignatures } from '@/api/signatureElectronique';
import { OPENNED, ARCHIVED } from '@/configuration/signatureElectronique/signatureElectroniqueConf';
import popUpChangementCommercial from '@/components/general/popUpChangementCommercial';
import { COMMERCIAL } from '@/configuration/parametrage/secteurConf';
import getSecteursIdByUser from '@/services/commun/secteur/getSecteurs';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import tagList from '@/components/general/tagList';
import filtreListeCommandeDevis from './filtreListeCommandeDevis';
import confirmationSuppressionCommande from './confirmationSuppressionCommande';

const Devis = createNamespacedHelpers('devis');
const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'DevisCommandesRechercheDevis',
  data() {
    return {
      isComponentSupprimerDevis: false,
      critereRecherche: null,
      showFiltre: false,
      selectAllValue: false,
      isSelectOnly: false,
      devisASupp: [],
      type: devisConf.TYPE_DEVIS,
      permDevis: DEVIS,
      commande: devisConf.ETAT_COMMANDE,
      sansSuite: devisConf.ETAT_SANSSUITE,
      unsubscribeValue: null,
      pdf: TYPE_PDF,
      typeEditionDevis: devisConf.TYPE_EDITION_DEVIS,
      sens: devisConf.SENS_VENTE,
      constantes: {
        ETAT_BROUILLON: devisConf.ETAT_BROUILLON,
        ETAT_COMMANDE_PARTIELLEMENT: devisConf.ETAT_COMMANDE_PARTIELLEMENT,
      },
      referenceTable: REFERENCE_TABLE_DEVIS,
      openPopUpSansSuite: false,
      openPopupMassCommercial: false,
      isErrorPopup: false,
      messagesPopup: [],
      signaturesHisto: [],
      mountedLoadingEnd: false,
      startArrayRendering: false,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    tagList,
    appConfirmationSuppressionCommande: confirmationSuppressionCommande,
    AppBreadcrumb,
    filtreListeCommandeDevis,
    selecteurActions,
    TableItemsInView,
    BtnActionIcon,
    parametrageTable,
    tableFooterTotaux,
    PopUpPrevention,
    exportExcelButton,
    popUpChangementCommercial,
    routerLinkBlank,
  },
  beforeDestroy() {
    this.unsubscribeValue();
    this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.goFirstPageAndCheckChangement, this.recherche);
      const critere = cloneDeep(genererCritereRecherche());
      await updateCritereWithParametreInterne(critere, this.user, this.$route.params.tiersId);
      await this.loadParametres([PARAMETRES_KEYS.tag]);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.signatureElectronique.key,
      ]);
      const secteurIdsCurrentUser = (await getSecteursIdByUser(COMMERCIAL)).map(e => e.id);
      if (secteurIdsCurrentUser.length) critere.secteurIds = secteurIdsCurrentUser;
      this.critereRecherche = critere;
      if (this.$route.params.sens) {
        this.sens = this.$route.params.sens;
      }
      this.mountedLoadingEnd = true;
      this.setInformationPage(this.$t('pageGescom.devis.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...Devis.mapGetters({
      devis: 'devis',
      totalDevis: 'totalDevis',
      lastPayload: 'lastPayload',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeDevis.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeDevis.title'), route: { name: 'l.bodac.devis' }, isActive: true },
      ];
    },
    actions() {
      const actions = [
        { action: ACTION_DELETE, translation: 'listeClients.actions.delete' },
        { action: devisConf.ACTION_SANS_SUITE, translation: 'listeDevis.actions.sansSuite' },
      ];
      if (!this.modulePresseActive) {
        actions.push({
          action: ACTION_MASS_CHANGER_COMMERCIAL,
          translation: 'listeDevis.actions.changementCommercial',
        });
      }
      return actions;
    },
    iconSelectTotal() {
      if (this.allDevisSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    nombreCritere() {
      let nombreCritere = 0;
      nombreCritere += this.critereRecherche.referenceClient ? 1 : 0;
      nombreCritere += this.critereRecherche.tiersId.length ? 1 : 0;
      nombreCritere += this.critereRecherche.codeDossier ? 1 : 0;
      nombreCritere += this.critereRecherche.departements
        ? this.critereRecherche.departements.length : 0;
      if (this.critereRecherche.datesPremierAffichage) {
        nombreCritere += this.critereRecherche.datesPremierAffichage.dateDebut ? 1 : 0;
        nombreCritere += this.critereRecherche.datesPremierAffichage.dateFin ? 1 : 0;
      }
      nombreCritere += this.critereRecherche.etat ? this.critereRecherche.etat.length : 0;
      nombreCritere += this.critereRecherche.categorieVente
        ? this.critereRecherche.categorieVente.length : 0;
      nombreCritere += this.critereRecherche.type ? this.critereRecherche.type.length : 0;
      nombreCritere += this.critereRecherche.commercialId
        ? this.critereRecherche.commercialId.length : 0;
      nombreCritere += this.critereRecherche.agencesId ? this.critereRecherche.agencesId.length : 0;
      nombreCritere += this.critereRecherche.assistantIds
      && this.critereRecherche.assistantIds.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.groupeIds.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.enseigneIds.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.themes.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.clients.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.produitsIds.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.planMediaIds.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.estSigne !== null ? 1 : 0;
      if (this.critereRecherche.dates) {
        nombreCritere += this.critereRecherche.dates.dateDebut ? 1 : 0;
        nombreCritere += this.critereRecherche.dates.dateFin ? 1 : 0;
      }
      if (this.critereRecherche.datesValidite) {
        nombreCritere += this.critereRecherche.datesValidite.dateDebut ? 1 : 0;
        nombreCritere += this.critereRecherche.datesValidite.dateFin ? 1 : 0;
      }
      nombreCritere += this.critereRecherche.secteurIds?.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.estSigneElectroniquement !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.tagIds?.length > 0 ? 1 : 0;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    targetTotal() {
      return ['montantHt'];
    },
    columns() {
      return ['selected', 'code', 'categorieVente', 'dateDevisCommande', 'commercialId', 'listeIntervenants', 'etat', 'estSigne', 'datePremierAffichage', 'codeDossier', 'montantHt', 'editer', 'modifier', 'archive', 'supprimer'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeDevis.table.code'),
          codeDossier: this.$i18n.t('listeDevis.table.folderCode'),
          dateDevisCommande: this.$i18n.t('listeDevis.table.date'),
          commercialId: this.$i18n.t('listeDevis.table.commercial'),
          listeIntervenants: this.$i18n.t('listeDevis.table.customers'),
          etat: this.$i18n.t('listeDevis.table.status'),
          montantHt: this.$i18n.t('listeDevis.table.amountHt'),
          datePremierAffichage: this.$i18n.t('listeDevis.table.datePremierAffichage'),
          categorieVente: this.$i18n.t('listeDevis.table.typeProduit'),
          estSigne: this.$i18n.t('listeDevis.table.estSigne'),
          modifier: '',
          supprimer: '',
          editer: '',
          archive: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['dateDevisCommande', 'montantHt', 'etat', 'code', 'codeDossier', 'datePremierAffichage', 'categorieVente', 'estSigne'],
        columnsClasses: {
          selected: 'colonneSelected',
          modifier: 'colonneSelected',
          supprimer: 'colonneSelected',
          editer: 'colonneSelected',
          archive: 'colonneSelected',
          listeIntervenants: 'ellipsis colonneListeIntervenants',
        },
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.critereRecherche);
          this.gestionDataLoadDevis(data);
          return this.actionsLoadDevis(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.devis,
            count: this.totalDevis,
          };
        }),
      };
    },
    allDevisSelected() {
      return this.getAllDevisSelected().length === this.devis.length;
    },
    moduleSignatureElectroniqueActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.signatureElectronique.key);
    },
    exportExcelQuery() {
      return {
        typeDonnee: devisConf.EXPORT_EXCEL_DEVIS,
        typeExport: null,
        filtres: {
          query: transform(this.lastPayload),
        },
      };
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Devis.mapActions({
      actionsLoadDevis: 'loadDevis',
    }),
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    updateMassCommercial() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.recherche();
        this.openPopupMassCommercial = false;
        loadingComponent.close();
        messageSuccess(this.$i18n.t('general.popUpChangementCommercial.success'));
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    getListeTags(row) {
      if (!row?.tags.length) return [];
      const tagIds = row?.tags.map(t => t.tagId);
      return this.parametre(PARAMETRES_KEYS.tag).filter((t) => tagIds.includes(t.id));
    },
    getLibelleCategorieVente(categorieVente) {
      const categorieFind = CATEGORIE_PRODUIT.find((categorie) => {
        return categorie.code === categorieVente;
      });
      return categorieFind ? categorieFind.libelle : '';
    },
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeCommandeDevis.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    async edition(donnees, id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    goFirstPageAndCheckChangement() {
      if (this.critereRecherche.agencesId.length === 0) return;
      const agencesId = [];
      this.critereRecherche.agencesId.forEach((id) => {
        const findInAgencesSelectionnes = this.agencesSelectionnees.some((agenceSelectionne) => {
          return agenceSelectionne.agenceId === id;
        });
        if (findInAgencesSelectionnes) agencesId.push(id);
      });
      this.critereRecherche.agencesId = agencesId;
      this.$refs[this.referenceTable].setPage(1);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    gestionDataLoadDevis(data) {
      checkPeriodeAndFormat(data.query, 'datesPremierAffichage');
      checkPeriodeAndFormat(data.query, 'dates');
      checkPeriodeAndFormat(data.query, 'datesValidite');
      data.query.societeId = this.societeActiveId;
      data.query.sens = this.sens;
      data.query.tagIds = tagInputToArray(this.critereRecherche.tagIds, 'id');
      if (this.critereRecherche.agencesId.length === 0) {
        data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
      }
      if (data.query.groupeIds.length > 0) {
        data.query.groupeIds = data.query.groupeIds.map((groupe) => { return groupe.id; });
      }
      if (data.query.enseigneIds.length > 0) {
        data.query.enseigneIds = data.query.enseigneIds.map((enseigne) => { return enseigne.id; });
      }
      if (data.query.clients.length > 0) {
        data.query.tiersId = data.query.clients.map((client) => { return client.id; });
      }
      if (data.query.produitsIds.length > 0) {
        data.query.produitsIds = data.query.produitsIds.map((p) => { return p.id; });
      }
      if (data.query.planMediaIds.length > 0) {
        data.query.planMediaIds = data.query.planMediaIds.map((p) => { return p.id; });
      }
      delete data.query.clients;
      data.query.etat = tagInputToArray(this.critereRecherche.etat, 'code');
      data.query.categorieVente = tagInputToArray(this.critereRecherche.categorieVente, 'code');
      if (!data.query.etat) {
        data.query.etat = [
          devisConf.ETAT_ENREGISTRE,
          devisConf.ETAT_COMMANDE,
          devisConf.ETAT_FACTURE,
          devisConf.ETAT_FACTURE_PARTIELLEMENT,
          devisConf.ETAT_COMMANDE_PARTIELLEMENT,
          devisConf.ETAT_BROUILLON,
        ];
      }
    },
    rechargementSuiteSuppression() {
      this.isComponentSupprimerDevis = false;
      this.devisASupp = [];
      this.recherche();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    async finLoading() {
      this.loadingComponent.close();
      if (this.moduleSignatureElectroniqueActive) await this.getAllSignaturesForDevis();
    },
    getAllDevisSelected() {
      return this.devis.filter((el) => { return el.selected; });
    },
    selectAll() {
      const select = !this.allDevisSelected;
      this.devis.forEach((el) => { el.selected = select; });
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    suppressionSelection() {
      this.devisASupp = this.devis.filter((el) => {
        return el.selected;
      });
      this.isComponentSupprimerDevis = true;
    },
    supprimerDevis(devisASupp) {
      this.devisASupp.push(devisASupp);
      this.isComponentSupprimerDevis = true;
    },
    handleAction(action) {
      switch (action) {
        case devisConf.ACTION_SANS_SUITE:
          if (this.checkPermissions(this.permDevis.maj)) {
            this.messagesPopup = [];
            this.isErrorPopup = false;
            this.openPopUpSansSuite = true;
          } else this.showPopUp();
          break;
        case ACTION_DELETE:
          if (this.checkPermissions(this.permDevis.supprimer)) {
            this.inProgress();
          } else this.showPopUp();
          break;
        case ACTION_MASS_CHANGER_COMMERCIAL:
          if (this.checkPermissions(this.permDevis.maj)) {
            this.openPopupMassCommercial = true;
          } else this.showPopUp();
          break;
        default:
          break;
      }
    },
    async reinitialiser() {
      await this.$refs.filtreListeCommandeDevis.initializeFiltre();
      await this.$refs.filtreListeCommandeDevis.viderCritere();
      this.$refs.filtreListeCommandeDevis.appliquerCritere();
      this.showFiltre = false;
    },
    async classerSansSuite() {
      const loadingComponent = this.$buefy.loading.open();
      const rsltOfSansSuite = await devisSansSuiteMulti(this.getAllDevisSelected());
      loadingComponent.close();
      if (rsltOfSansSuite.nbDevisReussi) {
        messageSuccess(this.$i18n.t(
          'listeDevis.popUpSansSuiteMessSuccess', { numDevis: rsltOfSansSuite.nbDevisReussi },
        ));
      }
      if (rsltOfSansSuite.errors.length > 0) {
        this.messagesPopup = rsltOfSansSuite.errors;
        this.isErrorPopup = true;
      } else this.openPopUpSansSuite = false;
      this.recherche();
    },
    async getAllSignaturesForDevis() {
      if (!this.devis.length) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.signaturesHisto = (await getAllSignatures({
          query: {
            referenceIds: this.devis.map(el => el.id),
            societeId: this.societeActiveId,
          },
          MaxResultCount: NO_PAGINATION,
          SkipCount: 0,
        })).data.result.items;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    checkDesactiveButton(devisId) {
      if (!this.signaturesHisto.length) return false;
      return this.signaturesHisto.filter(el => el.referenceId === devisId)
        .some(el => el.contratEtatSignature === OPENNED
          || el.contratEtatSignature === ARCHIVED);
    },
  },
};
</script>

<style>
  .colonneListeIntervenants {
    min-width: 7vw;
    max-width: 20vw;
  }
</style>
